
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({})

/**
 * JigBlockquote.vue
 *
 * Semantic blockquote + attribution footer used for testimonials.
 * Props:
 * - quote: quoted text
 * - authorName, authorRole, orgName: attribution shown in the footer.
 */
export default class JigBlockquoteVue extends Vue {
  @Prop({ default: '' })
  authorName!: string
  @Prop({ default: '' })
  authorRole!: string
  @Prop({ default: '' })
  orgName!: string
  @Prop({ default: '' })
  quote!: string
}
